
<div>
    <div
        class="readonly-label primary--text"
    >
        {{ label }}
    </div>
    <div
        class="readonly-value v-flex"
        :class="clazz"
        :style="style"
    >
        <div class="w-100 pr-1">
            {{ value }}
        </div>
        <v-spacer />
        <div>
            <slot name="prepend"></slot>
        </div>
    </div>
</div>
